import React, {useEffect, useState} from "react";
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from "react-router-dom";
import StepContext from "../Contexts/StepContext";
import PalInput from "./PalInput";
import PalRadioOption from "./PalRadioOption";
import PalCheckBoxOption from "./PalCheckBoxOption";
import PalSliderInput from "./PalSliderInput";
import fetchServerResponse from "../severGetHandling";
import PalFileLoader from "./PalFileLoader";
import getCookie from "../getCookie";

export default function DashboardSetup() {
    const [stepCount, setStepCount] = useState(0);
    const [initialContent, setInitialContent] =useState({});
    const navigate = useNavigate();
    useEffect(() => {
        const checkAuthentication = async () => {
          const isAuthenticated = getCookie("auth-cookie");
          
          if (!isAuthenticated) {
            // Navigate to login if not authenticated
            navigate("/login");
          }
        };
    
        checkAuthentication();
      }, []);



    const { data: serverGetResponse, isLoading } = useQuery(
        ["serverGetResponse","getinfo/profile-complete" ],
        () => fetchServerResponse("getinfo/profileComplete")
      );
    
    useEffect(()=>{
        if(!isLoading){
            if(serverGetResponse.exists && stepCount<=3){
                setStepCount(3);
            }
        }
    }, [stepCount,isLoading])
    
    const incrementStepCount  = () =>{
        setStepCount(prevStepCount => {
            const newStepCount = prevStepCount + 1;
            return newStepCount;
        });
    }

    const DashboardDisplay = () =>{
       
        if(stepCount === 0){
            return <PalInput
            endpoint= "palintroduction"
            altcontent = "Hey there, I'm Pal! Your go-to writing buddy, here to zap away your writer's block and bring out your inner wordsmith. What's your name, my talented friend?"
            label = "name"
            placeHolder="Enter Your Name"
            />;
        }

        if(stepCount === 1){
            return <PalRadioOption
            endpoint= "getWritingStyle"
            altcontent = "What do you enjoy writing?"
            label = "writingStyle"
            option = {["Poetry", "Prose", "Both I love to write!"]}
            />;
        }

        if(stepCount === 2){
            return <PalCheckBoxOption
            endpoint= "schedule"
            altcontent = "Creating a writing schedule can greatly improve your writing productivity and help you stay consistent with your writing goals. To get started, which days of the week would you like to set aside for writing?"
            label = "schedule"
            option = {["Sunday", "Monday","Tuesday","Wednesday", "Thursday", "Friday", "Saturday"]}
            />;
        }
        
        if(stepCount === 3){
            return <PalFileLoader
            endpoint= "load"
            altcontent = "Please select a project that you want to work on"/>
          
        }

        if(stepCount === 4){    
            
            
            return <PalSliderInput
            endpoint= "settime"
            altcontent = "Great to have you here! Let's kickstart your writing session. How long would you like to write for today?|"
            />;
    
        }

        
        if(stepCount === 5){
            console.log("This is the initial content" + initialContent);
            navigate("/writingarea", { state: { existingContent: initialContent } });
         }
    }

    return(
            
        <div>
        {isLoading? (<div>Loading</div>): (
            <StepContext.Provider value = {{stepCount, incrementStepCount, setInitialContent}}>
                 <div>
                     {DashboardDisplay()}  
                </div>
            </StepContext.Provider> )
            }
        </div>
    )

}